import { CompanyService, UserService } from '../services/';

const namespace = 'user';

export const FETCH_PROFILE = `${namespace}/FETCH_PROFILE`;
export const PROFILE_RECEIVED = `${namespace}/PROFILE_RECEIVED`;
export const COMPANY_RECEIVED = `${namespace}/OMPANY_RECEIVED`;
export const USER_LOGOUT = `${namespace}/USER_LOGOUT`;
export const FETCH_DRIVERS = `${namespace}/FETCH_DRIVERS`;
export const DRIVERS_RECEIVED = `${namespace}/DRIVERS_RECEIVED`;
export const CREATE_DRIVER = `${namespace}/CREATE_DRIVER`;
export const DRIVER_CREATED = `${namespace}/DRIVER_CREATED`;
export const FETCH_USERS = `${namespace}/FETCH_USERS`;
export const USERS_RECEIVED = `${namespace}/USERS_RECEIVED`;
export const CREATE_USER = `${namespace}/CREATE_USER`;
export const USER_CREATED = `${namespace}/USER_CREATED`;

const profileReceived = (profile) => {
  return {
    type: PROFILE_RECEIVED,
    profile
  }
}

export const getProfile = () => {
  return (dispatch, getState) => {
    const state = getState();
    const profile = state.auth.auth.getProfile();
    return dispatch(profileReceived(profile));
  }
}

const companyReceived = (company) => {
  return {
    type: COMPANY_RECEIVED,
    company
  }
}

export const getCompany = () => {
  return (dispatch, getState) => {
    const state = getState();
    return CompanyService.getForUser(state.auth.auth).then(company => dispatch(companyReceived(company)));
  }
}

export const logoutUser = () => {
  return {
    type: USER_LOGOUT
  }
}

const fetchDrivers = () => {
  return {
    type: FETCH_DRIVERS
  }
}

const driversReceived = (drivers) => {
  return {
    type: DRIVERS_RECEIVED,
    drivers
  }
}

export const getDrivers = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchDrivers());
    return UserService.getDrivers(state.auth.auth).then(drivers => dispatch(driversReceived(drivers)));
  }
}

const createADriver = () => {
  return {
    type: CREATE_DRIVER
  }
}

const driverCreated = (driver) => {
  return {
    type: DRIVER_CREATED,
    driver
  }
}

export const createDriver = (driver) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(createADriver());
    return UserService.createDriver(state.auth.auth, driver).then(d => {
      dispatch(driverCreated(d));
      return d;
    });
  }
}

const fetchUsers = () => {
  return {
    type: FETCH_USERS
  }
}

const usersReceived = (users) => {
  return {
    type: USERS_RECEIVED,
    users
  }
}

export const getUsers = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchUsers());
    return UserService.getUsers(state.auth.auth).then(users => dispatch(usersReceived(users)));
  }
}

const createAUser = () => {
  return {
    type: CREATE_USER,
  }
}

const userCreated = (user) => {
  return {
    type: USER_CREATED,
    user
  }
}

export const createUser = (user) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(createAUser());
    return UserService.createUser(state.auth.auth, user).then(u => {
      dispatch(userCreated(u));
      return u;
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/UserActions.js